import { YStack } from 'tamagui'

interface ContainerProps {
  children: React.ReactNode
  maxWidth?: number
  padding?: number
  py?: string | number
  px?: string | number
  centered?: boolean
  [key: string]: any // for other Tamagui props
}

export default function Container({
  children,
  maxWidth = 1140,
  padding = 16,
  py,
  px,
  centered = true,
  ...props
}: ContainerProps) {
  return (
    <YStack
      w="100%"
      maw={centered ? maxWidth : '100%'}
      mx={centered ? "auto" : undefined}
      px={px ?? padding}
      py={py}
      {...props}
    >
      {children}
    </YStack>
  )
}